import React, { useState, useEffect } from 'react';
import { Eye, Edit, Download, Plus, X, Search, Paperclip, Send, FileText } from 'lucide-react';
import CertificadoDoc from './certificado_admision.docx';
import * as XLSX from 'xlsx';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import JSZip from 'jszip';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export default function KardexEstMatriculacion({ readOnly = false, hideHeader = false }) {
  const [showModal, setShowModal] = useState(false);
  const [showDocModal, setShowDocModal] = useState(false);
  const [showDetallesModal, setShowDetallesModal] = useState(false);
  const [paymentConfig, setPaymentConfig] = useState(null);
  const [estudiantes, setEstudiantes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const currentYear = new Date().getFullYear();
  const [editingId, setEditingId] = useState(null);
  const [selectedEstudiante, setSelectedEstudiante] = useState(null);
  const [comentarioEdit, setComentarioEdit] = useState({});
  const [carreras, setCarreras] = useState([]);
  const [menciones, setMenciones] = useState([]);
  const [estudiantesAprobados, setEstudiantesAprobados] = useState([]);
  const [selectedAprobado, setSelectedAprobado] = useState('');
  const [loadingAprobados, setLoadingAprobados] = useState(false);
  const [searchAprobado, setSearchAprobado] = useState('');
  const [showAprobadoDropdown, setShowAprobadoDropdown] = useState(false);

  // Estados para búsqueda global (Re-matriculación)
  const [searchGlobal, setSearchGlobal] = useState('');
  const [globalResults, setGlobalResults] = useState([]);
  const [showGlobalDropdown, setShowGlobalDropdown] = useState(false);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [showSolModal, setShowSolModal] = useState(false);
  const [selectedSolMessage, setSelectedSolMessage] = useState('');

  // Estados para flujo de autorización de edición
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingEditEstudiante, setPendingEditEstudiante] = useState(null);

  const initialFormData = {
    carrera: '', mencion: '', modalidadPostulacion: '',
    nombres: '', apellidoPaterno: '', apellidoMaterno: '',
    cedulaIdentidad: '', extension: '', complemento: '',
    fechaNacimiento: '', edad: '', lugarNacimiento: '', lugarNacimientoOtro: '',
    sexo: '',
    direccion: '', numeroTelefono: '', correoElectronico: '',
    familiarNombre: '', familiarParentesco: '', familiarTelefono: '',
    emergenciaNombre: '', emergenciaParentesco: '', emergenciaTelefono: '',
    tipoSangre: '', alergias: '', enfermedadBase: '', lesiones: '',
    // Datos de usuario
    username: '', password: ''
  };

  const [formData, setFormData] = useState(initialFormData);

  const initialDocuments = [
    { id: 1, name: 'Formulario de Registro', file: null, currentUrl: null, estado: null },
    { id: 2, name: 'Comprobante de Depósito Bancario', file: null, currentUrl: null, estado: null },
    { id: 3, name: 'Documento de Identidad (C.I.)', file: null, currentUrl: null, estado: null },
    { id: 4, name: 'Seguro Médico / Certificado de Salud', file: null, currentUrl: null, estado: null },
    { id: 5, name: 'Certificado de Nacimiento', file: null, currentUrl: null, estado: null },
    { id: 6, name: 'Diploma / Título de Bachiller', file: null, currentUrl: null, estado: null },
    { id: 7, name: 'Carta / Acta de Compromiso', file: null, currentUrl: null, estado: null }
  ];

  const [documents, setDocuments] = useState(initialDocuments);

  // Estado para validación de periodo
  const [periodoCerrado, setPeriodoCerrado] = useState(false);
  const [mensajePeriodo, setMensajePeriodo] = useState('');
  const [fechaLimite, setFechaLimite] = useState(null);

  useEffect(() => { loadEstudiantes(); loadCarreras(); checkPeriodo(); }, []);

  // Verificar periodo de matriculación
  const checkPeriodo = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/verificar-periodo/inscripcion_matriculacion`);
      const data = await response.json();
      if (!data.permitido) {
        setPeriodoCerrado(true);
        setMensajePeriodo(data.mensaje || 'La acción no se encuentra habilitada en la fecha actual. Por favor, verifique el periodo establecido por Dirección Académica.');
      } else {
        setPeriodoCerrado(false);
        setMensajePeriodo(data.mensaje || 'Periodo de matriculación abierto.');
      }
      if (data.periodo && data.periodo.fecha_fin) {
        setFechaLimite(data.periodo.fecha_fin);
      }
    } catch (error) {
      console.error('Error verificando periodo:', error);
    }
  };

  useEffect(() => {
    if (showModal) {
      fetch(`${API_URL}/auth/payment-config/preadmision`)
        .then(res => res.json())
        .then(data => setPaymentConfig(data))
        .catch(err => console.error('Error:', err));
    }
  }, [showModal]);

  useEffect(() => {
    if (formData.fechaNacimiento) {
      const birthDate = new Date(formData.fechaNacimiento);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
      setFormData(prev => ({ ...prev, edad: age.toString() }));
    }
  }, [formData.fechaNacimiento]);

  useEffect(() => {
    if (formData.carrera) {
      fetch(`${API_URL}/jefatura/menciones?id_carrera=${formData.carrera}`)
        .then(res => res.json())
        .then(data => setMenciones(data.menciones || []))
        .catch(() => setMenciones([]));
    }
  }, [formData.carrera]);

  // Cargar estudiantes aprobados cuando cambia la modalidad
  useEffect(() => {
    if (formData.modalidadPostulacion && formData.modalidadPostulacion !== 'Re-matriculación') {
      loadEstudiantesAprobados(formData.modalidadPostulacion);
    } else {
      setEstudiantesAprobados([]);
      setSelectedAprobado('');
    }
  }, [formData.modalidadPostulacion]);



  const handleSearchGlobal = async (term) => {
    setSearchGlobal(term);
    if (term.length < 3) {
      setGlobalResults([]);
      setShowGlobalDropdown(false);
      return;
    }
    setLoadingGlobal(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/kardex/estudiantes-search/global?q=${term}`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });
      const data = await response.json();
      setGlobalResults(data.estudiantes || []);
      setShowGlobalDropdown(true);
    } catch (error) {
      console.error('Error searching global:', error);
    } finally {
      setLoadingGlobal(false);
    }
  };

  const handleSelectGlobal = (est) => {
    // Auto-llenar formulario con datos del estudiante antiguo
    setFormData(prev => ({
      ...prev,
      nombres: est.nombres || '',
      apellidoPaterno: est.apellido_paterno || '',
      apellidoMaterno: est.apellido_materno || '',
      cedulaIdentidad: est.cedula_identidad || '',
      extension: est.extension || '',
      complemento: est.complemento || '',
      fechaNacimiento: est.fecha_nacimiento ? est.fecha_nacimiento.split('T')[0] : '',
      lugarNacimiento: est.lugar_nacimiento || '',
      sexo: est.sexo || '',
      direccion: est.direccion || '',
      numeroTelefono: est.telefono || '',
      correoElectronico: est.email || '',
      familiarNombre: est.familiar_nombre || '',
      familiarTelefono: est.familiar_telefono || '',
      familiarParentesco: est.familiar_parentesco || '',
      emergenciaNombre: est.emergencia_nombre || '',
      emergenciaTelefono: est.emergencia_telefono || '',
      emergenciaParentesco: est.emergencia_parentesco || '',
      tipoSangre: est.tipo_sangre || '',
      alergias: est.alergias || '',
      enfermedadBase: est.enfermedad_base || '',
      lesiones: est.lesiones || '',
      // Mantener carrera y mencion si ya las seleccionó el usuario, o usar las del estudiante si están vacías
      carrera: prev.carrera || est.id_carrera || '',
      mencion: prev.mencion || est.id_mencion || ''
    }));
    setSearchGlobal(`${est.nombres} ${est.apellido_paterno} - CI: ${est.cedula_identidad}`);
    setShowGlobalDropdown(false);
  };

  const loadEstudiantesAprobados = async (modalidad) => {
    setLoadingAprobados(true);
    try {
      const token = localStorage.getItem('token');
      const modalidadMap = {
        'Curso de Preadmisión': 'CPA',
        'Prueba de Admisión Académica': 'PAA',
        'Admisión Especial': 'Admision Especial'
      };
      const codigo = modalidadMap[modalidad] || modalidad;
      const response = await fetch(`${API_URL}/kardex/estudiantes-aprobados?modalidad=${encodeURIComponent(codigo)}`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });
      const data = await response.json();
      console.log('🔍 Respuesta API estudiantes aprobados:', data);
      console.log('🔍 Primer estudiante (estructura):', data.estudiantes?.[0]);
      setEstudiantesAprobados(data.estudiantes || []);
    } catch (error) {
      console.error('Error loading estudiantes aprobados:', error);
      setEstudiantesAprobados([]);
    } finally {
      setLoadingAprobados(false);
    }
  };

  const handleSelectAprobado = (id) => {
    setSelectedAprobado(id);
    if (!id) return;

    const estudiante = estudiantesAprobados.find(e => String(e.id_inscripcion) === String(id));
    if (estudiante) {
      // Auto-llenar formulario con TODOS los datos del estudiante aprobado
      setFormData(prev => ({
        ...prev,
        nombres: estudiante.nombres || '',
        apellidoPaterno: estudiante.primer_apellido || '',
        apellidoMaterno: estudiante.segundo_apellido || '',
        cedulaIdentidad: estudiante.cedula_identidad || '',
        extension: estudiante.extension || '',
        complemento: estudiante.complemento || '',
        fechaNacimiento: estudiante.fecha_nacimiento ? estudiante.fecha_nacimiento.split('T')[0] : '',
        lugarNacimiento: estudiante.lugar_nacimiento || '',
        sexo: estudiante.sexo || '',
        direccion: estudiante.direccion || '',
        numeroTelefono: estudiante.telefono || '',
        correoElectronico: estudiante.email || '',
        familiarNombre: estudiante.familiar_nombre || '',
        familiarTelefono: estudiante.familiar_telefono || '',
        familiarParentesco: estudiante.familiar_parentesco || '',
        emergenciaNombre: estudiante.emergencia_nombre || '',
        emergenciaTelefono: estudiante.emergencia_telefono || '',
        emergenciaParentesco: estudiante.emergencia_parentesco || '',
        tipoSangre: estudiante.tipo_sangre || '',
        alergias: estudiante.alergias || '',
        enfermedadBase: estudiante.enfermedad_base || '',
        lesiones: estudiante.lesiones || '',
      }));

      const dbFields = {
        1: 'doc_formulario',
        2: 'doc_comprobante',
        3: 'doc_cedula',
        4: 'doc_seguro',
        5: 'doc_nacimiento',
        6: 'doc_titulo',
        7: 'doc_compromiso',
        'doc_formulario': 'doc_formulario',
        'doc_comprobante': 'doc_comprobante',
        'doc_cedula': 'doc_cedula',
        'doc_seguro': 'doc_seguro',
        'doc_nacimiento': 'doc_nacimiento',
        'doc_titulo': 'doc_titulo',
        'doc_compromiso': 'doc_compromiso'
      };

      setDocuments(prevDocs => prevDocs.map(doc => {
        const fieldName = dbFields[doc.id];
        const valorUrl = fieldName ? estudiante[fieldName] : null;

        return {
          ...doc,
          file: null,
          currentUrl: valorUrl || null,
          estado: valorUrl ? 'aprobado' : null
        };
      }));
    }
  };

  const loadCarreras = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/jefatura/carreras`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });
      const data = await response.json();
      setCarreras(data.carreras || []);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const loadEstudiantes = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/kardex/estudiantes?tipo=matriculacion`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });
      const data = await response.json();
      setEstudiantes(data.estudiantes || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (docId, e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Si estamos en el modal de añadir nuevo estudiante (no hay editingId y showModal es true)
    // solo guardamos el archivo en el estado local para enviarlo luego en handleSubmit
    if (showModal && !editingId) {
      setDocuments(prev => prev.map(doc =>
        doc.id === docId ? { ...doc, file, estado: 'listo' } : doc
      ));
      return;
    }

    // Modo edición de documentos (estudiante ya existente)
    if (!selectedEstudiante) return;

    // Mostrar estado "subiendo"
    setDocuments(prev => prev.map(doc =>
      doc.id === docId ? { ...doc, file, estado: 'subiendo' } : doc
    ));

    // Mapeo de IDs a nombres de campo
    const docFieldMap = {
      1: 'doc_formulario',
      2: 'doc_comprobante',
      3: 'doc_cedula',
      4: 'doc_seguro',
      5: 'doc_nacimiento',
      6: 'doc_titulo',
      7: 'doc_compromiso',
      8: 'doc_foto'
    };

    try {
      const submitData = new FormData();
      submitData.append(docFieldMap[docId], file);

      const response = await fetch(`${API_URL}/kardex/estudiantes/${selectedEstudiante.id_estudiante}/documentos`, {
        method: 'POST',
        body: submitData
      });

      if (response.ok) {
        // Actualizar a estado aprobado (check verde)
        setDocuments(prev => prev.map(doc =>
          doc.id === docId ? { ...doc, file, estado: 'aprobado' } : doc
        ));
        // Recargar lista para actualizar porcentaje
        loadEstudiantes();
      } else {
        const error = await response.json();
        alert(`Error: ${error.message}`);
        setDocuments(prev => prev.map(doc =>
          doc.id === docId ? { ...doc, file: null, estado: null } : doc
        ));
      }
    } catch (error) {
      console.error('Error uploading:', error);
      alert('Error al subir documento');
      setDocuments(prev => prev.map(doc =>
        doc.id === docId ? { ...doc, file: null, estado: null } : doc
      ));
    }
  };

  const calcularPorcentajeDoc = (est) => {
    const totalDocs = 7;
    let docsSubidos = 0;
    if (est.doc_formulario) docsSubidos++;
    if (est.doc_comprobante) docsSubidos++;
    if (est.doc_cedula) docsSubidos++;
    if (est.doc_seguro) docsSubidos++;
    if (est.doc_nacimiento) docsSubidos++;
    if (est.doc_titulo) docsSubidos++;
    if (est.doc_compromiso) docsSubidos++;
    return Math.round((docsSubidos / totalDocs) * 100);
  };

  const handleSubmit = async () => {
    if (periodoCerrado && !editingId) {
      alert(`⚠️ ${mensajePeriodo}`);
      return;
    }

    // Validar capacidad de carrera (Frontend Check)
    if (!editingId && formData.carrera) {
      const c = carreras.find(c => String(c.id_carrera) === String(formData.carrera));
      if (c && c.inscritos >= c.capacidad) {
        alert(`❌ Cupo máximo alcanzado para la carrera ${c.nombre} (${c.inscritos}/${c.capacidad}). No se puede matricular más estudiantes.`);
        return;
      }
    }

    try {
      const lugarFinal = formData.lugarNacimiento === 'Otro' ? formData.lugarNacimientoOtro : formData.lugarNacimiento;

      // If editing, use FormData to support file changes
      if (editingId) {
        const updateData = new FormData();
        updateData.append('tipo', 'matriculacion');
        updateData.append('id_carrera', formData.carrera || '');
        updateData.append('id_mencion', formData.mencion || '');
        updateData.append('modalidad_postulacion', formData.modalidadPostulacion || '');
        updateData.append('nombres', formData.nombres || '');
        updateData.append('apellido_paterno', formData.apellidoPaterno || '');
        updateData.append('apellido_materno', formData.apellidoMaterno || '');
        updateData.append('cedula_identidad', formData.cedulaIdentidad || '');
        updateData.append('extension', formData.extension || '');
        updateData.append('complemento', formData.complemento || '');
        updateData.append('fecha_nacimiento', formData.fechaNacimiento || '');
        updateData.append('lugar_nacimiento', lugarFinal || '');
        updateData.append('sexo', formData.sexo || '');
        updateData.append('direccion', formData.direccion || '');
        updateData.append('telefono', formData.numeroTelefono || '');
        updateData.append('email', formData.correoElectronico || '');
        updateData.append('familiar_nombre', formData.familiarNombre || '');
        updateData.append('familiar_parentesco', formData.familiarParentesco || '');
        updateData.append('familiar_telefono', formData.familiarTelefono || '');
        updateData.append('emergencia_nombre', formData.emergenciaNombre || '');
        updateData.append('emergencia_parentesco', formData.emergenciaParentesco || '');
        updateData.append('emergencia_telefono', formData.emergenciaTelefono || '');
        updateData.append('tipo_sangre', formData.tipoSangre || '');
        updateData.append('alergias', formData.alergias || '');
        updateData.append('enfermedad_base', formData.enfermedadBase || '');
        updateData.append('lesiones', formData.lesiones || '');

        // Add document files if they exist
        const docFieldMap = {
          1: 'doc_formulario',
          2: 'doc_comprobante',
          3: 'doc_cedula',
          4: 'doc_seguro',
          5: 'doc_nacimiento',
          6: 'doc_titulo',
          7: 'doc_compromiso',
          8: 'doc_foto'
        };

        documents.forEach(doc => {
          if (doc.file && docFieldMap[doc.id]) {
            updateData.append(docFieldMap[doc.id], doc.file);
          }
        });

        const response = await fetch(`${API_URL}/kardex/estudiantes/${editingId}`, {
          method: 'PUT',
          body: updateData
        });

        if (response.ok) {
          // Consumir la autorización después de guardar exitosamente
          await fetch(`${API_URL}/kardex/consumir-edicion/${editingId}`, {
            method: 'PUT'
          });
          alert('Actualizado exitosamente');
          resetForm();
          loadEstudiantes();
        } else {
          const data = await response.json();
          alert(data.message || 'Error al actualizar');
        }
        return;
      }

      // For NEW students or Matricular Approved/Special, use FormData with files
      const submitData = new FormData();

      // Add text fields
      submitData.append('tipo', 'matriculacion');
      if (selectedAprobado) {
        submitData.append('id_inscripcion', selectedAprobado);
      }
      submitData.append('id_carrera', formData.carrera || '');
      submitData.append('id_mencion', formData.mencion || '');
      submitData.append('modalidad_postulacion', formData.modalidadPostulacion || '');
      submitData.append('nombres', formData.nombres || '');
      submitData.append('apellido_paterno', formData.apellidoPaterno || '');
      submitData.append('apellido_materno', formData.apellidoMaterno || '');
      submitData.append('cedula_identidad', formData.cedulaIdentidad || '');
      submitData.append('extension', formData.extension || '');
      submitData.append('complemento', formData.complemento || '');
      submitData.append('fecha_nacimiento', formData.fechaNacimiento || '');
      submitData.append('lugar_nacimiento', lugarFinal || '');
      submitData.append('sexo', formData.sexo || '');
      submitData.append('direccion', formData.direccion || '');
      submitData.append('telefono', formData.numeroTelefono || '');
      submitData.append('email', formData.correoElectronico || '');
      submitData.append('familiar_nombre', formData.familiarNombre || '');
      submitData.append('familiar_parentesco', formData.familiarParentesco || '');
      submitData.append('familiar_telefono', formData.familiarTelefono || '');
      submitData.append('emergencia_nombre', formData.emergenciaNombre || '');
      submitData.append('emergencia_parentesco', formData.emergenciaParentesco || '');
      submitData.append('emergencia_telefono', formData.emergenciaTelefono || '');
      submitData.append('tipo_sangre', formData.tipoSangre || '');
      submitData.append('alergias', formData.alergias || '');
      submitData.append('enfermedad_base', formData.enfermedadBase || '');
      submitData.append('lesiones', formData.lesiones || '');
      submitData.append('username', formData.username || '');
      submitData.append('password', formData.password || '');

      // Add document files - map document IDs to field names
      const docFieldMap = {
        1: 'doc_formulario',
        2: 'doc_comprobante',
        3: 'doc_cedula',
        4: 'doc_seguro',
        5: 'doc_nacimiento',
        6: 'doc_titulo',
        7: 'doc_compromiso',
        8: 'doc_foto'
      };

      documents.forEach(doc => {
        if (doc.file && docFieldMap[doc.id]) {
          submitData.append(docFieldMap[doc.id], doc.file);
        }
      });

      // Route all non-editing flows to /matricular (it now handles everything)
      const response = await fetch(`${API_URL}/kardex/matricular`, {
        method: 'POST',
        body: submitData
      });

      if (response.ok) {
        const data = await response.json();
        alert(`✅ ${formData.nombres} ${formData.apellidoPaterno} ha sido matriculado exitosamente.\n\n🎓 Código asignado: ${data.codigo || 'L-XXX'}`);
        resetForm();
        loadEstudiantes();
      } else {
        const data = await response.json();
        alert(data.message || 'Error al guardar');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al guardar');
    }
  };

  const resetForm = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData(initialFormData);
    setDocuments(initialDocuments);
    setShowAprobadoDropdown(false);
    setSelectedAprobado('');
    setSearchGlobal('');
    setGlobalResults([]);
    setShowGlobalDropdown(false);
  };

  const getEstadoSolColor = (estado) => {
    switch (estado) {
      case 'pendiente': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'aprobado': return 'bg-green-100 text-green-800 border-green-200';
      case 'rechazado': return 'bg-red-100 text-red-800 border-red-200 cursor-pointer hover:bg-red-200';
      case 'actualizado': return 'bg-green-100 text-green-800 border-green-200'; // fondo verde, no gris
      case 'consumido': return 'bg-green-100 text-green-800 border-green-200'; // registros viejos → mismo verde
      default: return 'bg-gray-50 text-gray-400 border-gray-100';
    }
  };

  // Verificar autorización y manejar click en editar
  const handleEdit = async (est) => {
    try {
      // Verificar estado de autorización
      const response = await fetch(`${API_URL}/kardex/verificar-edicion/${est.id_estudiante}`);
      const data = await response.json();

      if (data.autorizado) {
        // Tiene autorización aprobada - abrir modal de edición
        openEditModal(est);
      } else if (data.solicitud_pendiente) {
        // Hay solicitud pendiente
        alert('Ya existe una solicitud de autorización pendiente para este estudiante. Por favor espere la respuesta de Dirección.');
      } else {
        // Sin autorización ni solicitud - mostrar confirmación
        setPendingEditEstudiante(est);
        setShowConfirmModal(true);
      }
    } catch (error) {
      console.error('Error verificando autorización:', error);
      alert('Error al verificar autorización');
    }
  };

  // Función para abrir el modal de edición (solo se llama si está autorizado)
  const openEditModal = (est) => {
    setEditingId(est.id_estudiante);
    setFormData({
      carrera: est.id_carrera || '',
      mencion: est.id_mencion || '',
      modalidadPostulacion: est.modalidad_postulacion || '',
      nombres: est.nombres || '',
      apellidoPaterno: est.apellido_paterno || '',
      apellidoMaterno: est.apellido_materno || '',
      cedulaIdentidad: est.cedula_identidad || '',
      extension: est.extension || '',
      complemento: est.complemento || '',
      fechaNacimiento: est.fecha_nacimiento ? est.fecha_nacimiento.split('T')[0] : '',
      edad: '',
      lugarNacimiento: est.lugar_nacimiento || '',
      lugarNacimientoOtro: '',
      direccion: est.direccion || '',
      numeroTelefono: est.telefono || '',
      correoElectronico: est.email || '',
      familiarNombre: est.familiar_nombre || '',
      familiarParentesco: est.familiar_parentesco || '',
      familiarTelefono: est.familiar_telefono || '',
      emergenciaNombre: est.emergencia_nombre || '',
      emergenciaParentesco: est.emergencia_parentesco || '',
      emergenciaTelefono: est.emergencia_telefono || '',
      tipoSangre: est.tipo_sangre || '',
      alergias: est.alergias || '',
      enfermedadBase: est.enfermedad_base || '',
      lesiones: est.lesiones || ''
    });
    setShowModal(true);
  };

  // Solicitar autorización a Dirección
  const solicitarAutorizacion = async () => {
    if (!pendingEditEstudiante) return;

    try {
      const response = await fetch(`${API_URL}/kardex/solicitar-edicion/${pendingEditEstudiante.id_estudiante}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id_solicitante: 1 }) // TODO: usar id del usuario actual
      });

      const data = await response.json();

      if (response.ok) {
        alert('Solicitud enviada a Dirección. Se le notificará cuando sea aprobada.');
        loadEstudiantes(); // Refrescar tabla para mostrar estado "pendiente" inmediatamente
      } else {
        alert(data.error || 'Error al enviar solicitud');
      }
    } catch (error) {
      console.error('Error solicitando autorización:', error);
      alert('Error al enviar solicitud');
    } finally {
      setShowConfirmModal(false);
      setPendingEditEstudiante(null);
    }
  };

  // Cancelar solicitud de autorización
  const cancelarSolicitud = () => {
    setShowConfirmModal(false);
    setPendingEditEstudiante(null);
  };

  const handleComentarioChange = (id, value) => {
    setComentarioEdit(prev => ({ ...prev, [id]: value }));
  };

  const enviarComentario = async (est) => {
    const comentario = comentarioEdit[est.id_estudiante];
    if (!comentario) return;
    try {
      await fetch(`${API_URL}/kardex/estudiantes/${est.id_estudiante}/comentario`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ comentario, enviar_email: true })
      });
      alert('Comentario guardado y enviado por correo');
      loadEstudiantes();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const descargarTodosAdjuntos = async (est) => {
    try {
      const studentId = est.id_estudiante || est.codigo || est.cedula_identidad;
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${API_URL}/kardex/estudiantes/${studentId}/documentos-zip`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      const safeCode = (est.codigo || est.codigo_estudiante || est.cedula_identidad || 'estudiante').replace(/\s+/g, '_');
      const safeName = `${est.apellido_paterno || ''}_${est.apellido_materno || ''}_${est.nombres || ''}`.trim().replace(/\s+/g, '_');
      link.download = `Documentos_${safeCode}_${safeName}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error al descargar ZIP:', error);
      alert('Ocurrió un error al descargar el archivo .zip de los documentos.');
    }
  };

  const abrirModalDocumentos = (est) => {
    setSelectedEstudiante(est);
    setDocuments([
      { id: 1, name: 'Formulario de Registro', file: null, estado: est.doc_formulario ? 'aprobado' : null, currentUrl: est.doc_formulario || null },
      { id: 2, name: 'Comprobante de Depósito Bancario', file: null, estado: est.doc_comprobante ? 'aprobado' : null, currentUrl: est.doc_comprobante || null },
      { id: 3, name: 'Documento de Identidad (C.I.)', file: null, estado: est.doc_cedula ? 'aprobado' : null, currentUrl: est.doc_cedula || null },
      { id: 4, name: 'Seguro Médico / Certificado de Salud', file: null, estado: est.doc_seguro ? 'aprobado' : null, currentUrl: est.doc_seguro || null },
      { id: 5, name: 'Certificado de Nacimiento', file: null, estado: est.doc_nacimiento ? 'aprobado' : null, currentUrl: est.doc_nacimiento || null },
      { id: 6, name: 'Diploma / Título de Bachiller', file: null, estado: est.doc_titulo ? 'aprobado' : null, currentUrl: est.doc_titulo || null },
      { id: 7, name: 'Carta / Acta de Compromiso', file: null, estado: est.doc_compromiso ? 'aprobado' : null, currentUrl: est.doc_compromiso || null }
    ]);
    setShowDocModal(true);
  };

  // Guardar documentos desde el modal del ojito
  const guardarDocumentos = async () => {
    if (!selectedEstudiante) return;

    // Check if any files were selected
    const filesSelected = documents.some(doc => doc.file);
    if (!filesSelected) {
      alert('No hay documentos nuevos para guardar');
      setShowDocModal(false);
      return;
    }

    try {
      const submitData = new FormData();
      submitData.append('id_estudiante', selectedEstudiante.id_estudiante);

      const docFieldMap = {
        1: 'doc_formulario',
        2: 'doc_comprobante',
        3: 'doc_cedula',
        4: 'doc_seguro',
        5: 'doc_nacimiento',
        6: 'doc_titulo',
        7: 'doc_compromiso',
        8: 'doc_foto'
      };

      documents.forEach(doc => {
        if (doc.file && docFieldMap[doc.id]) {
          submitData.append(docFieldMap[doc.id], doc.file);
        }
      });

      const response = await fetch(`${API_URL}/kardex/estudiantes/${selectedEstudiante.id_estudiante}/documentos`, {
        method: 'POST',
        body: submitData
      });

      if (response.ok) {
        alert('Documentos guardados exitosamente');
        setShowDocModal(false);
        loadEstudiantes();
      } else {
        const data = await response.json();
        alert(data.message || 'Error al guardar documentos');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al guardar documentos');
    }
  };

  const filtered = estudiantes.filter(e =>
    searchTerm === '' ||
    `${e.nombres} ${e.apellido_paterno} ${e.cedula_identidad} ${e.codigo || ''}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleMatricularPending = (est) => {
    const idInscripcion = est.id_inscripcion_base || (est.id_estudiante && est.id_estudiante.toString().startsWith('pending_')
      ? est.id_estudiante.replace('pending_', '')
      : null);

    // Resetear estados de búsqueda previos
    setSearchAprobado('');
    setSearchGlobal('');
    setGlobalResults([]);

    // IMPORTANTE: Establecer id_inscripcion para que el flujo de matriculación sepa a quién actualizar
    if (idInscripcion) {
      setSelectedAprobado(idInscripcion);
    }

    setShowModal(true);

    // Auto-llenar formulario con los datos que ya tenemos del backend
    setFormData({
      carrera: est.id_carrera || '',
      mencion: est.id_mencion || '',
      modalidadPostulacion: est.modalidad_postulacion || '',
      nombres: est.nombres || '',
      apellidoPaterno: est.apellido_paterno || '',
      apellidoMaterno: est.apellido_materno || '',
      cedulaIdentidad: est.cedula_identidad || '',
      extension: est.extension || '',
      complemento: est.complemento || '',
      fechaNacimiento: est.fecha_nacimiento ? est.fecha_nacimiento.split('T')[0] : '',
      edad: est.edad || '',
      lugarNacimiento: est.lugar_nacimiento || '',
      sexo: est.sexo || '',
      direccion: est.direccion || '',
      numeroTelefono: est.telefono || '',
      correoElectronico: est.email || '',
      familiarNombre: est.familiar_nombre || '',
      familiarParentesco: est.familiar_parentesco || '',
      familiarTelefono: est.familiar_telefono || '',
      emergenciaNombre: est.emergencia_nombre || '',
      emergenciaParentesco: est.emergencia_parentesco || '',
      emergenciaTelefono: est.emergencia_telefono || '',
      tipoSangre: est.tipo_sangre || '',
      alergias: est.alergias || '',
      enfermedadBase: est.enfermedad_base || '',
      lesiones: est.lesiones || '',
      username: est.username || '',
      password: ''
    });

    if (idInscripcion) {
      setSelectedAprobado(idInscripcion);
      setSearchAprobado(`${est.nombres} ${est.apellido_paterno} - CI: ${est.cedula_identidad}`);
    }
  };

  const abrirDetalles = (est) => {
    setSelectedEstudiante(est);
    setShowDetallesModal(true);
  };

  // Descargar Hoja de Registro Personal
  const descargarRegistroPersonal = (est, index) => {
    const fechaNac = est.fecha_nacimiento ? new Date(est.fecha_nacimiento).toLocaleDateString('es-BO') : '';
    // Usar el código real del estudiante si existe, sino formatear el ID
    const codigo = est.codigo || `L-${String(est.id_estudiante || index + 1).padStart(3, '0')}`;

    // Helper para marcar X
    const check = (val) => val ? 'X' : '';

    const html = `
<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <title>Hoja de Registro Personal</title>
    <style>
        body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; margin: 30px; }
        h1, h2 { text-align: center; margin: 5px 0; }
        h1 { font-size: 16px; }
        h2 { font-size: 13px; text-align: left; margin-top: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 5px; }
        td, th { border: 1px solid #000; padding: 4px 6px; vertical-align: middle; }
        .no-border { border: none !important; }
        .center { text-align: center; }
        .right { text-align: right; }
        .blue { background: #9db7e8; font-weight: bold; }
        .checkbox { width: 14px; height: 14px; border: 1px solid #000; display: inline-block; text-align:center; line-height:14px; font-size:10px; }
        .photo-box { width: 120px; height: 150px; border: 2px dashed #000; text-align: center; vertical-align: middle; line-height: 150px; }
        .page-break { page-break-after: always; }
        .signature { margin-top: 50px; text-align: center; }
        @page { size: A4; margin: 20mm; }
        @media print { .no-print { display: none; } }
    </style>
</head>
<body>
    <button class="no-print" onclick="window.print()">Imprimir / Guardar PDF</button>
    
    <h1>HOJA DE REGISTRO PERSONAL</h1>
    
    <table class="no-border">
        <tr>
            <td class="no-border right"><strong>COD. ESTUDIANTIL:</strong></td>
            <td class="no-border" style="width:150px;border-bottom:1px solid #000;">${codigo}</td>
            <td class="no-border" style="width:150px;"></td>
            <td class="photo-box" rowspan="2">FOTOGRAFÍA</td>
        </tr>
    </table>

    <h2>1. DATOS PERSONALES</h2>
    <table>
        <tr class="blue center"><td>NOMBRE(S)</td><td>PRIMER APELLIDO</td><td>SEGUNDO APELLIDO</td></tr>
        <tr><td style="height:25px;">${est.nombres || ''}</td><td>${est.apellido_paterno || ''}</td><td>${est.apellido_materno || ''}</td></tr>
        <tr class="blue center"><td>C.I.</td><td>EXP.</td><td>EDAD</td></tr>
        <tr><td style="height:25px;">${est.cedula_identidad || ''}</td><td>${est.extension || ''}</td><td>${est.edad || ''}</td></tr>
        <tr class="blue center"><td>FECHA DE NACIMIENTO (dd/mm/aa)</td><td colspan="2">LUGAR DE NACIMIENTO</td></tr>
        <tr><td style="height:25px;">${fechaNac}</td><td colspan="2">${est.lugar_nacimiento || ''}</td></tr>
        <tr class="blue center"><td colspan="3">DIRECCIÓN / DOMICILIO ACTUAL</td></tr>
        <tr><td colspan="3" style="height:25px;">${est.direccion || ''}</td></tr>
        <tr class="blue center"><td>NÚMERO TELÉFONO / CELULAR</td><td colspan="2">E-MAIL</td></tr>
        <tr><td style="height:25px;">${est.telefono || ''}</td><td colspan="2">${est.email || ''}</td></tr>
    </table>

    <h2>2. REQUISITOS DE HABILITACIÓN (LLENADO POR KARDEX)</h2>
    <table>
        <tr class="blue center"><td>DOCUMENTO</td><td>CUENTA</td><td>NO CUENTA</td><td>NO CORRESPONDE</td><td>OBSERVACIONES</td></tr>
        <tr><td>1. FORMULARIO DE REGISTRO</td><td class="center"><div class="checkbox">${est.doc_formulario ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
        <tr><td>2. COMPROBANTE DE DEPÓSITO BANCARIO</td><td class="center"><div class="checkbox">${est.doc_comprobante ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
        <tr><td>3. DOCUMENTO DE IDENTIDAD (C.I.)</td><td class="center"><div class="checkbox">${est.doc_cedula ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
        <tr><td>4. SEGURO MÉDICO / CERTIFICADO MÉDICO</td><td class="center"><div class="checkbox">${est.doc_seguro ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
        <tr><td>5. CERTIFICADO DE NACIMIENTO</td><td class="center"><div class="checkbox">${est.doc_nacimiento ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
        <tr><td>6. DIPLOMA / TÍTULO DE BACHILLER</td><td class="center"><div class="checkbox">${est.doc_titulo ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
        <tr><td>7. CARTA / ACTA DE COMPROMISO</td><td class="center"><div class="checkbox">${est.doc_compromiso ? 'X' : ''}</div></td><td class="center"><div class="checkbox"></div></td><td class="center"><div class="checkbox"></div></td><td></td></tr>
    </table>

    <div class="page-break"></div>

    <h2>INFORMACIÓN MÉDICA</h2>
    <table>
        <tr class="blue center"><td>TIPO DE SANGRE</td><td>ALERGIAS</td></tr>
        <tr><td style="height:25px;">${est.tipo_sangre || ''}</td><td>${est.alergias || ''}</td></tr>
        <tr class="blue center"><td colspan="2">ENFERMEDADES DE BASE</td></tr>
        <tr><td colspan="2" style="height:25px;">${est.enfermedad_base || ''}</td></tr>
        <tr class="blue center"><td colspan="2">LESIONES U OTROS VINCULADOS A SU SALUD</td></tr>
        <tr><td colspan="2" style="height:25px;">${est.lesiones || ''}</td></tr>
    </table>

    <h2>DATOS DE FAMILIAR CERCANO</h2>
    <table>
        <tr class="blue center"><td>NOMBRE Y APELLIDO</td><td>PARENTESCO</td><td>TELÉFONO</td></tr>
        <tr><td style="height:25px;">${est.familiar_nombre || ''}</td><td>${est.familiar_parentesco || ''}</td><td>${est.familiar_telefono || ''}</td></tr>
    </table>

    <h2>DATOS DE CONTACTO DE EMERGENCIA</h2>
    <table>
        <tr class="blue center"><td>NOMBRE Y APELLIDO</td><td>PARENTESCO</td><td>TELÉFONO</td></tr>
        <tr><td style="height:25px;">${est.emergencia_nombre || ''}</td><td>${est.emergencia_parentesco || ''}</td><td>${est.emergencia_telefono || ''}</td></tr>
    </table>

    <h2>3. DECLARACIÓN JURADA</h2>
    <table>
        <tr><td style="padding: 20px; text-align: justify; line-height: 1.5;">
        Yo ${est.nombres}  ${est.apellido_paterno} ${est.apellido_materno}, hábil por derecho, con Cédula de Identidad N° ${est.cedula_identidad} ${est.extension}, de manera voluntaria acepto los términos establecidos en la Convocatoria y sus procesos de admisión y registro, así mismo declaro en honor a la verdad, que cumplo a cabalidad con los requisitos indispensables exigidos en la convocatoria, siendo que todos los datos proporcionados en el presente formulario son verídicos, por lo que autorizo que la información proporcionada sea verificada y contrastada por la EBID, comprometiéndome a la presentación de la documentación original de acuerdo al cronograma establecido. 
        Asímismo, asumo plena responsabilidad por cualquier situación relacionada con mi salud o accidentes que pudieran ocurrir durante el desarrollo de mis actividades académicas y extracurriculares en la EBID. 
        En este sentido, autorizo/no autorizo a la EBID que, si fuera necesario, contacte a un familiar o contacto de emergencia cuando sea necesario. En caso de no estar de acuerdo con lo estipulado, exonero a la institución de toda responsabilidad respecto de accidentes relacionados a mi persona y de salud dentro de la Institución.
        </td></tr>   
    </table>

    <div class="signature">
        ..............................................................<br>
        <strong>Firma Estudiante</strong>
    </div>
</body>
</html>`;

    const win = window.open('', '_blank');
    if (win) {
      win.document.write(html);
      win.document.close();
    } else {
      alert('El navegador bloqueó la ventana emergente.');
    }
    const docFieldMap = {
      1: 'doc_formulario',
      2: 'doc_comprobante',
      3: 'doc_cedula',
      4: 'doc_seguro',
      5: 'doc_nacimiento',
      6: 'doc_titulo',
      7: 'doc_compromiso',
      8: 'doc_foto'
    };

    setDocuments(initialDocuments.map(doc => {
      const fieldName = docFieldMap[doc.id];
      const valorGuardado = fieldName ? est[fieldName] : null;
      return {
        ...doc,
        file: null,
        currentUrl: valorGuardado || null,
        estado: valorGuardado ? 'aprobado' : null
      };
    }));
  };

  // Descargar Certificado de Admisión (Documento Word) - Autollenado
  const descargarCertificadoAdmision = async (est) => {
    try {
      console.log('Iniciando descarga de certificado para:', est.nombres);

      // 1. Cargar el template
      const response = await fetch(CertificadoDoc);
      if (!response.ok) throw new Error('No se pudo cargar la plantilla del servidor');
      const content = await response.arrayBuffer();

      // 2. Inicializar
      const zip = new PizZip(content);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });

      // 2.5. Obtener materias y notas del estudiante
      let materias = [];
      try {
        const gradesResponse = await fetch(`${API_URL}/estudiante/notas-periodo?id_usuario=${est.id_usuario}&anio=${currentYear}&periodo=final`);
        const gradesData = await gradesResponse.json();
        if (gradesData && gradesData.notas) {
          materias = gradesData.notas.map(n => ({
            asignatura: (n.asignatura || '').toUpperCase(),
            nota_final: n.nota_final || '0.0'
          }));
        }
      } catch (err) {
        console.error('Error recuperando notas para el certificado:', err);
      }

      // 3. Preparar datos
      const carreraObj = carreras.find(c => String(c.id_carrera) === String(est.id_carrera));
      const data = {
        nombres: (est.nombres || '').toUpperCase(),
        apellido_paterno: (est.apellido_paterno || '').toUpperCase(),
        apellido_materno: (est.apellido_materno || '').toUpperCase(),
        nombre_completo: `${est.nombres || ''} ${est.apellido_paterno || ''} ${est.apellido_materno || ''}`.trim().toUpperCase(),
        cedula_identidad: est.cedula_identidad || '',
        extension: est.extension || '',
        ci_full: `${est.cedula_identidad || ''} ${est.extension || ''}`.trim(),
        carrera: (est.carrera_nombre || carreraObj?.nombre || est.carrera || '').toUpperCase(),
        mencion: (est.mencion_nombre || est.mencion || 'SIN MENCIÓN').toUpperCase(),
        codigo: est.codigo || `L-${String(est.id_estudiante).padStart(3, '0')}`,
        gestion: currentYear,
        fecha_nacimiento: est.fecha_nacimiento ? new Date(est.fecha_nacimiento).toLocaleDateString('es-BO') : '',
        lugar_nacimiento: (est.lugar_nacimiento || '').toUpperCase(),
        direccion: (est.direccion || '').toUpperCase(),
        telefono: est.telefono || est.numero_telefono || '',
        email: est.email || est.correo_electronico || '',
        familiar_nombre: (est.familiar_nombre || '').toUpperCase(),
        familiar_parentesco: (est.familiar_parentesco || '').toUpperCase(),
        familiar_telefono: est.familiar_telefono || '',
        emergencia_nombre: (est.emergencia_nombre || '').toUpperCase(),
        emergencia_parentesco: (est.emergencia_parentesco || '').toUpperCase(),
        emergencia_telefono: est.emergencia_telefono || '',
        tipo_sangre: est.tipo_sangre || '',
        alergias: (est.alergias || 'NINGUNA').toUpperCase(),
        enfermedad_base: (est.enfermedad_base || 'NINGUNA').toUpperCase(),
        lesiones: (est.lesiones || 'NINGUNA').toUpperCase(),
        serie: est.serie || '',
        codigo: est.codigo || '',
        promedio: est.promedio_general || '0.0',
        promedio_general: est.promedio_general || '0.0',
        materias: materias, // Lista de materias para el bucle {#materias}
        fecha_hoy: new Date().toLocaleDateString('es-BO', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        })
      };

      console.log('Datos a insertar:', data);

      // 4. Renderizar con captura de errores detallada
      try {
        doc.render(data);
      } catch (error) {
        console.error('Error detallado de Docxtemplater:', error);
        if (error.properties && error.properties.errors instanceof Array) {
          const errorMessages = error.properties.errors.map(e => e.message).join('\n');
          console.error('Errores en las etiquetas del Word:', errorMessages);
          alert('El archivo Word tiene errores en las etiquetas (llaves { } mal cerradas o mal escritas).');
        }
        throw error;
      }

      // 5. Generar y descargar
      const out = doc.getZip().generate({
        type: 'blob',
        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      });

      const url = window.URL.createObjectURL(out);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Certificado_Admision_${est.nombres.replace(/\s+/g, '_')}_${est.apellido_paterno.replace(/\s+/g, '_')}.docx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error general:', error);
      alert('No se pudo generar el documento. Asegúrese de que el archivo Word tenga las etiquetas correctas como {nombre_completo}, {cedula_identidad}, etc.');
    }
  };
  const extensiones = ['LP', 'CB', 'SC', 'OR', 'PT', 'TJ', 'CH', 'BN', 'PD'];
  const departamentos = ['La Paz', 'Cochabamba', 'Santa Cruz', 'Oruro', 'Potosí', 'Tarija', 'Chuquisaca', 'Beni', 'Pando'];

  return (
    <div className="p-6">
      {!hideHeader && !readOnly && (
        <div className="mb-4 flex justify-between items-center">
          <h1 className="text-xl font-bold text-gray-800">Kardex &gt; Estudiantes &gt; Licenciatura</h1>
          <div className="flex items-center gap-3">
            {periodoCerrado ? (
              <div className="px-4 py-1.5 bg-red-100 border border-red-200 text-red-700 rounded-full flex items-center gap-2 animate-pulse">
                <X size={16} className="bg-red-500 text-white rounded-full p-0.5" />
                <span className="text-sm font-bold uppercase tracking-wider">Matriculación Cerrada</span>
              </div>
            ) : (
              <div className="px-4 py-1.5 bg-green-100 border border-green-200 text-green-700 rounded-full flex items-center gap-2">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
                <span className="text-sm font-bold uppercase tracking-wider">Habilitado</span>
                {fechaLimite && (
                  <span className="text-xs ml-1 font-medium bg-green-500 text-white px-2 py-0.5 rounded-md">
                    Hasta: {new Date(fechaLimite).toLocaleDateString()}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="mb-6 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
        <div className="flex flex-wrap gap-4 items-end ">
          {!readOnly && (
            <>
              <button
                onClick={() => {
                  if (periodoCerrado) {
                    alert(mensajePeriodo);
                    return;
                  }
                  resetForm();
                  setShowModal(true);
                }}
                className={`flex items-center gap-2 px-4 py-2 rounded-full ${periodoCerrado ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-800'} text-white shadow-sm transition`}
              >
                <Plus size={20} />
                <span className="font-medium">Matricular</span>
              </button>
            </>
          )}
          {/* Buscar y Descargar */}
          <div className="flex-grow flex items-end gap-2">
            <div className="relative flex-grow">
              <div className="relative">
                <Search className="absolute left-3 top-2.5 text-gray-400" size={16} />
                <input
                  type="text"
                  placeholder="Buscar por nombre, apellido o CI..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 hover:border-blue-500"
                />
              </div>
            </div>

          </div>

          <button
            onClick={() => {
              // Excel Export con TODOS los campos
              const headers = [
                'N° Serie', 'Código', 'Carrera', 'Mención', 'Nombres', 'Apellidos', 'CI', 'Ext', 'Fecha Nacimiento', 'Edad', 'Lugar Nacimiento', 'Sexo',
                'Dirección', 'Teléfono', 'Email',
                'Nombre Familiar', 'Parentesco Familiar', 'Tel Familiar',
                'Nombre Emergencia', 'Parentesco Emergencia', 'Tel Emergencia',
                'Tipo Sangre', 'Alergias', 'Enfermedad Base', 'Lesiones'
              ];
              const anio = currentYear;
              const rows = filtered.map((e, i) => [
                e.serie || '-',
                e.codigo || '-',
                e.carrera_nombre || '',
                e.mencion_nombre || '',
                e.nombres || '',
                `${e.apellido_paterno || ''} ${e.apellido_materno || ''} `.trim(),
                e.cedula_identidad || '',
                e.extension || '',
                e.fecha_nacimiento ? new Date(e.fecha_nacimiento).toLocaleDateString() : '',
                e.edad || '',
                e.lugar_nacimiento || '',
                e.sexo || '',
                e.direccion || '',
                e.telefono || '',
                e.email || '',
                e.familiar_nombre || '',
                e.familiar_parentesco || '',
                e.familiar_telefono || '',
                e.emergencia_nombre || '',
                e.emergencia_parentesco || '',
                e.emergencia_telefono || '',
                e.tipo_sangre || '',
                e.alergias || '',
                e.enfermedad_base || '',
                e.lesiones || ''
              ]);

              const csv = [headers.join(','), ...rows.map(r => r.map(c => `"${String(c || '').replace(/"/g, '""')}"`).join(','))].join('\n');
              const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `matriculados_completos_${new Date().toISOString().split('T')[0]}.csv`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(link.href);
            }}
            className="p-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition shadow-sm" title="Descargar Excel Completo"
          >
            <Download size={20} />
          </button>
        </div>
      </div>
      {/* Toolbar */}
      {/* <div className="mb-4 flex flex-wrap gap-3 items-center">
        {!readOnly && (
          <>
            <button
              onClick={() => {
                if (periodoCerrado) {
                  alert(mensajePeriodo);
                  return;
                }
                resetForm();
                setShowModal(true);
              }}
              className={`flex items-center gap-2 px-4 py-2 rounded-full ${periodoCerrado ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-800'} text-white shadow-sm transition`}
            >
              <Plus size={20} />
              <span className="font-medium">Matricular</span>
            </button>
          </>
        )}

        <div className="flex-1 max-w-md relative">
          <input
            type="text"
            placeholder="Buscar por CI o nombre..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-full"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
        </div>

        <button
          onClick={() => {
            // Excel Export con TODOS los campos
            const headers = [
              'N° Serie', 'Código', 'Carrera', 'Mención', 'Nombres', 'Apellidos', 'CI', 'Ext', 'Fecha Nacimiento', 'Edad', 'Lugar Nacimiento', 'Sexo',
              'Dirección', 'Teléfono', 'Email',
              'Nombre Familiar', 'Parentesco Familiar', 'Tel Familiar',
              'Nombre Emergencia', 'Parentesco Emergencia', 'Tel Emergencia',
              'Tipo Sangre', 'Alergias', 'Enfermedad Base', 'Lesiones'
            ];
            const anio = currentYear;
            const rows = filtered.map((e, i) => [
              e.serie || '-',
              e.codigo || '-',
              e.carrera_nombre || '',
              e.mencion_nombre || '',
              e.nombres || '',
              `${e.apellido_paterno || ''} ${e.apellido_materno || ''} `.trim(),
              e.cedula_identidad || '',
              e.extension || '',
              e.fecha_nacimiento ? new Date(e.fecha_nacimiento).toLocaleDateString() : '',
              e.edad || '',
              e.lugar_nacimiento || '',
              e.sexo || '',
              e.direccion || '',
              e.telefono || '',
              e.email || '',
              e.familiar_nombre || '',
              e.familiar_parentesco || '',
              e.familiar_telefono || '',
              e.emergencia_nombre || '',
              e.emergencia_parentesco || '',
              e.emergencia_telefono || '',
              e.tipo_sangre || '',
              e.alergias || '',
              e.enfermedad_base || '',
              e.lesiones || ''
            ]);

            const csv = [headers.join(','), ...rows.map(r => r.map(c => `"${String(c || '').replace(/"/g, '""')}"`).join(','))].join('\n');
            const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `matriculados_completos_${new Date().toISOString().split('T')[0]}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
          }}
          className="p-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition shadow-sm" title="Descargar Excel Completo"
        >
          <Download size={20} />
        </button>
      </div> */}

      {/* Tabla unificada */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto max-w-full">
          <table className="w-full text-xs whitespace-nowrap">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-2 py-3 text-center font-semibold border">Serie</th>
                <th className="px-2 py-3 text-center font-semibold border">Código</th>
                <th className="px-2 py-3 text-center font-semibold border">Estudiante</th>
                <th className="px-2 py-3 text-center font-semibold border">Carrera / Mención</th>
                <th className="px-2 py-3 text-center font-semibold border">CI / Exp.</th>
                <th className="px-2 py-3 text-center font-semibold border">Contacto</th>
                <th className="px-2 py-3 text-center font-semibold border">% Doc</th>
                <th className="px-2 py-3 text-center font-semibold border">Estado/Matrícula</th>
                {!readOnly ? (
                  <>
                    <th className="px-2 py-3 text-center font-semibold border">Acciones</th>
                    <th className="px-2 py-3 text-center font-semibold border">Comentarios</th>
                    <th className="px-2 py-3 text-center font-semibold border">Estado Solicitud edición</th>
                  </>
                ) : (
                  <th className="px-4 py-4 text-center font-bold uppercase tracking-wider">Ver Detalles</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="px-6 py-12 text-center text-gray-500 animate-pulse bg-gray-50/30">
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                      <span className="font-medium italic">Cargando información del sistema...</span>
                    </div>
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan="10" className="px-6 py-16 text-center text-gray-400 bg-gray-50/20 italic">
                    No se encontraron registros que coincidan con la búsqueda
                  </td>
                </tr>
              ) : (
                filtered.map((est, index) => (
                  <tr key={est.id_estudiante || index} className="hover:bg-gray-50">
                    {/* <td className="px-2 py-4 text-center font-mono font-bold text-blue-900 bg-blue-50/10 group-hover:bg-blue-100/30 whitespace-nowrap">
                      {est.serie || '-'}
                    </td> */}
                    <td className="px-2 py-3 text-center border">
                      {est.serie ? est.serie.replace(/^SERIE-/, '') : '-'}
                    </td>
                    <td className="px-2 py-3 text-center border">
                      {est.codigo || '-'}
                    </td>
                    <td className="px-2 py-3 border">
                      <div className="flex flex-col">
                        <span className="font-bold text-gray-800 uppercase leading-tight">{est.nombres}</span>
                        <span className="text-gray-500 font-medium">{est.apellido_paterno} {est.apellido_materno}</span>
                      </div>
                    </td>
                    <td className="px-2 py-3 border">
                      <div className="flex flex-col">
                        <span className="font-semibold text-blue-700 leading-tight">
                          {carreras.find(c => String(c.id_carrera) === String(est.id_carrera))?.nombre || est.carrera_nombre}
                        </span>
                        <span className="text-gray-500 italic text-[10px]">{est.mencion_nombre || 'Sin mención'}</span>
                      </div>
                    </td>
                    <td className="px-2 py-3 text-center border">
                      <span>
                        {est.cedula_identidad} {est.extension}
                      </span>
                    </td>
                    <td className="px-2 py-3 border">
                      <div className="flex flex-col text-[10px]">
                        <span className="text-gray-600 font-medium">📞 {est.numero_telefono || est.telefono || '-'}</span>
                        <span className="text-blue-500 hover:underline">{est.correo_electronico || '-'}</span>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-center border">
                      <div className="flex flex-col items-center gap-1">
                        <div className="w-12 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                          <div
                            className={`h-full transition-all duration-500 ${calcularPorcentajeDoc(est) === 100 ? 'bg-green-500' : 'bg-blue-500'}`}
                            style={{ width: `${calcularPorcentajeDoc(est)}%` }}
                          ></div>
                        </div>
                        <span className="font-bold text-blue-600 tabular-nums">{calcularPorcentajeDoc(est)}%</span>
                      </div>
                    </td>
                    <td className="px-2 py-3 text-center border">
                      {['aprobado', 'admision_aprobado'].includes(est.etapa_academica) ? (
                        <button
                          onClick={() => handleMatricularPending(est)}
                          className="px-4 py-1.5 bg-blue-900 text-white text-[10px] font-bold rounded-full hover:bg-blue-800 shadow-sm transition-all active:scale-95"
                        >
                          Matricular
                        </button>
                      ) : (
                        <button
                          disabled
                          className="px-4 py-1.5 bg-gray-100 text-gray-400 text-[10px] font-bold rounded-full border border-gray-200 cursor-not-allowed"
                        >
                          Matriculado
                        </button>
                      )}
                    </td>
                    {!readOnly ? (
                      <>
                        <td className="px-2 py-3 border">
                          <div className="flex items-center justify-center gap-1.5 opacity-90 group-hover:opacity-100">
                            <button onClick={() => abrirDetalles(est)} className="p-2 text-blue-600 hover:bg-blue-100 rounded-full transition-all hover:scale-110 shadow-sm bg-white" title="Perfil completo">
                              <Eye size={16} />
                            </button>
                            <button onClick={() => abrirModalDocumentos(est)} className="p-2 text-green-600 hover:bg-green-100 rounded-full transition-all hover:scale-110 shadow-sm bg-white" title="Expediente digital">
                              <FileText size={16} />
                            </button>
                            <button onClick={() => handleEdit(est)} className="p-2 text-amber-600 hover:bg-amber-100 rounded-full transition-all hover:scale-110 shadow-sm bg-white" title="Editar">
                              <Edit size={16} />
                            </button>
                            <button onClick={() => descargarTodosAdjuntos(est)} className="p-2 text-indigo-600 hover:bg-indigo-100 rounded-full transition-all hover:scale-110 shadow-sm bg-white" title="Bajar adjuntos">
                              <Download size={16} />
                            </button>
                            <button onClick={() => descargarRegistroPersonal(est, index)} className="p-2 text-purple-600 hover:bg-purple-100 rounded-full transition-all hover:scale-110 shadow-sm bg-white" title="Kardex personal">
                              <FileText size={16} />
                            </button>
                            <button onClick={() => descargarCertificadoAdmision(est)} className="p-2 text-orange-600 hover:bg-orange-100 rounded-full transition-all hover:scale-110 shadow-sm bg-white" title="Bajar certificado">
                              <Download size={16} />
                            </button>
                          </div>
                        </td>
                        <td className="px-2 py-3 border">
                          <div className="flex items-center gap-1.5 min-w-[120px]">
                            <input
                              type="text"
                              value={comentarioEdit[est.id_estudiante] ?? est.comentarios ?? ''}
                              onChange={(e) => handleComentarioChange(est.id_estudiante, e.target.value)}
                              className="flex-1 px-2 py-1.5 text-[10px] border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-100 focus:border-blue-300 bg-white"
                              placeholder="Escribir nota..."
                            />
                            <button onClick={() => enviarComentario(est)} className="p-2 text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg transition-all shadow-sm bg-white border border-blue-50" title="Notificar">
                              <Send size={13} />
                            </button>
                          </div>
                        </td>
                        <td className="px-2 py-3 text-center border">
                          {est.ultima_solicitud ? (
                            <span
                              onClick={() => {
                                if (est.ultima_solicitud.estado === 'rechazado') {
                                  setSelectedSolMessage(est.ultima_solicitud.observaciones || 'Sin observaciones');
                                  setShowSolModal(true);
                                }
                              }}
                              className={`px-2 py-1 rounded-full text-[10px] font-bold border ${getEstadoSolColor(est.ultima_solicitud.estado)} transition-colors`}
                              title={est.ultima_solicitud.estado === 'rechazado' ? 'Ver motivo de rechazo' : ''}
                            >
                              {est.ultima_solicitud.estado === 'aprobado'
                                ? 'Solicitud aprobada'
                                : est.ultima_solicitud.estado === 'consumido'
                                  ? 'ACTUALIZADO'
                                  : est.ultima_solicitud.estado.toUpperCase()}
                            </span>
                          ) : (
                            <span className="text-gray-300 text-[10px]">-</span>
                          )}
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-4 py-4">
                          <div className="flex items-center justify-center gap-3">
                            <button onClick={() => abrirDetalles(est)} className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg transition-all font-semibold">
                              <Eye size={14} /> <span>Ver Perfil</span>
                            </button>
                            <button onClick={() => descargarTodosAdjuntos(est)} className="p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-all border border-gray-100 shadow-sm">
                              <Download size={16} />
                            </button>
                          </div>
                        </td>
                        <td className="px-4 py-4 text-center">
                          <span className="text-gray-300 text-[10px]">-</span>
                        </td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal Añadir/Editar Estudiante */}
      {
        showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              {/* <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
                <h2 className="text-xl font-semibold">Añadir Nuevo Estudiante</h2>
                <button onClick={resetForm} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
              </div> */}
              <div className="bg-gray-50 px-6 py-4 border-b flex justify-between items-center flex-shrink-0">
                <div>
                  <h3 className="text-xl font-bold text-blue-900">Añadir Nuevo Estudiante
                  </h3>
                  {/* <p className="text-sm text-gray-600">filtered.map((est, index) (est.codigo))</p> */}
                </div>
                <button onClick={resetForm} className="text-gray-400 hover:text-gray-600">
                  <X size={24} />
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* 1. Datos Generales */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">1. Datos Generales</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Carrera*</label>
                      <select name="carrera" value={formData.carrera} onChange={handleInputChange}
                        className={`w-full px-3 py-2 border rounded-md transition-shadow ${formData.carrera && carreras.find(c => String(c.id_carrera) === String(formData.carrera))?.inscritos >= carreras.find(c => String(c.id_carrera) === String(formData.carrera))?.capacidad ? 'border-red-500 ring-2 ring-red-100' : 'focus:ring-2 focus:ring-blue-100'}`}
                      >
                        <option value="">Seleccionar</option>
                        {carreras.map(c => (
                          <option key={c.id_carrera} value={c.id_carrera}>
                            {c.nombre} {c.capacidad ? `(${c.inscritos}/${c.capacidad} cupos)` : ''}
                          </option>
                        ))}
                      </select>
                      {formData.carrera && (
                        <div className="mt-1 flex items-center justify-between">
                          {(() => {
                            const c = carreras.find(c => String(c.id_carrera) === String(formData.carrera));
                            if (!c) return null;
                            const full = c.inscritos >= c.capacidad;
                            return (
                              <>
                                <span className={`text-[10px] font-bold uppercase ${full ? 'text-red-600' : 'text-green-600'}`}>
                                  {full ? 'Cupos Agotados' : 'Cupos Disponibles'}
                                </span>
                                <div className="flex items-center gap-1">
                                  <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                                    <div
                                      className={`h-full ${full ? 'bg-red-500' : (c.inscritos / c.capacidad > 0.8 ? 'bg-yellow-500' : 'bg-green-500')}`}
                                      style={{ width: `${Math.min(100, (c.inscritos / (c.capacidad || 50)) * 100)}%` }}
                                    ></div>
                                  </div>
                                  <span className="text-[10px] text-gray-500 font-mono">{c.inscritos}/{c.capacidad}</span>
                                </div>
                              </>
                            );
                          })()}
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Mención*</label>
                      <select name="mencion" value={formData.mencion} onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md">
                        <option value="">Seleccionar</option>
                        {menciones.map(m => <option key={m.id_mencion} value={m.id_mencion}>{m.nombre}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Modalidad de Postulación*</label>
                      <select name="modalidadPostulacion" value={formData.modalidadPostulacion} onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md">
                        <option value="">Seleccionar modalidad</option>
                        <option value="Curso de Preadmisión">Curso de Preadmisión (CPA)</option>
                        <option value="Prueba de Admisión Académica">Prueba de Admisión Académica (PAA)</option>
                        <option value="Admisión Especial">Admisión Especial</option>
                        <option value="Re-matriculación">Re-matriculación (Estudiante Antiguo)</option>
                      </select>
                    </div>
                  </div>

                  {/* Selector de Estudiante Aprobado - Solo si es CPA, PAA o Admisión Especial */}
                  {formData.modalidadPostulacion && !['Re-matriculación'].includes(formData.modalidadPostulacion) && (
                    <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                      <label className="block text-sm font-medium mb-2 text-green-800">
                        Buscar Estudiante Aprobado ({formData.modalidadPostulacion})
                      </label>
                      {loadingAprobados ? (
                        <p className="text-sm text-gray-500">Cargando estudiantes aprobados...</p>
                      ) : estudiantesAprobados.length === 0 ? (
                        <p className="text-sm text-yellow-700 bg-yellow-50 p-2 rounded">
                          No hay estudiantes aprobados pendientes de matriculación en esta modalidad
                        </p>
                      ) : (
                        <div className="relative">
                          <div className="flex items-center">
                            <Search className="absolute left-3 text-gray-400" size={18} />
                            <input
                              type="text"
                              placeholder="Buscar por CI o nombre..."
                              value={searchAprobado}
                              onChange={(e) => {
                                setSearchAprobado(e.target.value);
                                setShowAprobadoDropdown(true);
                              }}
                              onFocus={() => setShowAprobadoDropdown(true)}
                              className="w-full pl-10 pr-4 py-2 border border-green-300 rounded-md bg-white focus:ring-2 focus:ring-green-500 focus:outline-none"
                            />
                          </div>
                          {showAprobadoDropdown && searchAprobado && (
                            <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                              {estudiantesAprobados
                                .filter(est => {
                                  if (!searchAprobado) return true; // sin texto = mostrar todos
                                  const search = searchAprobado.toLowerCase();
                                  return (
                                    est.cedula_identidad?.toLowerCase().includes(search) ||
                                    est.nombres?.toLowerCase().includes(search) ||
                                    est.primer_apellido?.toLowerCase().includes(search) ||
                                    est.segundo_apellido?.toLowerCase().includes(search)
                                  );
                                })
                                .slice(0, 10)
                                .map(est => (
                                  <div
                                    key={est.id_inscripcion}
                                    onClick={() => {
                                      handleSelectAprobado(est.id_inscripcion);
                                      setSearchAprobado(`${est.nombres} ${est.primer_apellido} - CI: ${est.cedula_identidad}`);
                                      setShowAprobadoDropdown(false);
                                    }}
                                    className="px-4 py-3 cursor-pointer hover:bg-green-50 border-b border-gray-100 last:border-0"
                                  >
                                    <div className="flex justify-between items-center">
                                      <div>
                                        <span className="font-medium text-gray-800">
                                          {est.nombres} {est.primer_apellido} {est.segundo_apellido || ''}
                                        </span>
                                        <span className="ml-2 text-sm text-gray-500">CI: {est.cedula_identidad}</span>
                                      </div>
                                      <div className="flex items-center gap-2">
                                        <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-800">
                                          Prom: {est.promedio_general || 'N/A'}
                                        </span>
                                        <span className="px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-800">
                                          {est.estado_aprobacion || 'Aprobado'}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="text-xs text-gray-500 mt-1">
                                      Código: {est.codigo || 'N/A'}
                                    </div>
                                  </div>
                                ))}
                              {estudiantesAprobados.filter(est => {
                                const search = searchAprobado.toLowerCase();
                                return est.cedula_identidad?.toLowerCase().includes(search) ||
                                  est.nombres?.toLowerCase().includes(search) ||
                                  est.primer_apellido?.toLowerCase().includes(search);
                              }).length === 0 && (
                                  <div className="px-4 py-3 text-sm text-gray-500 text-center">
                                    No se encontraron estudiantes con ese criterio
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      )}
                      <p className="mt-2 text-xs text-green-700">
                        Escriba CI o nombre para buscar. Al seleccionar un estudiante, sus datos se llenarán automáticamente.
                      </p>
                    </div>
                  )}

                  {/* Banner informativo: credenciales preservadas al seleccionar estudiante aprobado */}
                  {selectedAprobado && formData.modalidadPostulacion !== 'Re-matriculación' && (
                    <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2">
                      <span className="text-blue-500 mt-0.5">🔑</span>
                      <div className="text-xs text-blue-700">
                        <strong>Credenciales preservadas:</strong> El estudiante mantendrá el mismo usuario y contraseña que utilizaba durante su proceso de admisión. El campo de usuario/contraseña es <strong>opcional</strong> — si se deja vacío, se conservarán las credenciales originales.
                      </div>
                    </div>
                  )}

                  {/* Buscador Global para Re-matriculación */}
                  {formData.modalidadPostulacion === 'Re-matriculación' && (
                    <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                      <label className="block text-sm font-medium mb-2 text-blue-800">
                        Buscar Estudiante Antiguo (Re-matriculación)
                      </label>
                      <div className="relative">
                        <div className="flex items-center">
                          <Search className="absolute left-3 text-gray-400" size={18} />
                          <input
                            type="text"
                            placeholder="Buscar por CI o nombre..."
                            value={searchGlobal}
                            onChange={(e) => handleSearchGlobal(e.target.value)}
                            onFocus={() => { if (globalResults.length > 0) setShowGlobalDropdown(true); }}
                            className="w-full pl-10 pr-4 py-2 border border-blue-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                          />
                        </div>
                        {loadingGlobal && <p className="text-xs text-gray-500 mt-1">Buscando...</p>}

                        {showGlobalDropdown && globalResults.length > 0 && (
                          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                            {globalResults.map(est => (
                              <div
                                key={est.id_estudiante}
                                onClick={() => handleSelectGlobal(est)}
                                className="px-4 py-3 cursor-pointer hover:bg-blue-50 border-b border-gray-100 last:border-0"
                              >
                                <div className="flex justify-between items-center">
                                  <div>
                                    <span className="font-medium text-gray-800">
                                      {est.nombres} {est.apellido_paterno} {est.apellido_materno || ''}
                                    </span>
                                    <span className="ml-2 text-sm text-gray-500">CI: {est.cedula_identidad}</span>
                                  </div>
                                  <span className="px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-800">
                                    {est.carrera_nombre || 'Sin Carrera'}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {showGlobalDropdown && !loadingGlobal && globalResults.length === 0 && searchGlobal.length >= 3 && (
                          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-center text-gray-500">
                            No se encontraron estudiantes
                          </div>
                        )}
                      </div>
                      <p className="mt-2 text-xs text-blue-700">
                        Busque al estudiante antiguo para cargar sus datos automáticamente.
                      </p>
                    </div>
                  )}
                </div>

                {/* 2. Datos Personales */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">2. Datos Personales</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Nombres*</label>
                      <input type="text" name="nombres" value={formData.nombres} onChange={handleInputChange}
                        placeholder="Ingrese nombres" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Primer Apellido*</label>
                      <input type="text" name="apellidoPaterno" value={formData.apellidoPaterno} onChange={handleInputChange}
                        placeholder="Ingrese primer apellido" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Segundo Apellido</label>
                      <input type="text" name="apellidoMaterno" value={formData.apellidoMaterno} onChange={handleInputChange}
                        placeholder="Ingrese segundo apellido" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-4">
                    <div className="col-span-2">
                      <label className="block text-sm font-medium mb-1">Cédula de Identidad*</label>
                      <input type="text" name="cedulaIdentidad" value={formData.cedulaIdentidad} onChange={handleInputChange}
                        placeholder="Ej: 12345678" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Extensión</label>
                      <select name="extension" value={formData.extension} onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md">
                        <option value="">Seleccionar</option>
                        {extensiones.map(e => <option key={e} value={e}>{e}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Complemento</label>
                      <input type="text" name="complemento" value={formData.complemento} onChange={handleInputChange}
                        placeholder="Ej: 1A" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Fecha Nacimiento*</label>
                      <input type="date" name="fechaNacimiento" value={formData.fechaNacimiento} onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Edad*</label>
                      <input type="text" name="edad" value={formData.edad} readOnly
                        className="w-full px-3 py-2 border rounded-md bg-gray-100" placeholder="Calculado automáticamente" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Lugar Nacimiento*</label>
                      <select name="lugarNacimiento" value={formData.lugarNacimiento} onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md">
                        <option value="">Seleccionar</option>
                        {departamentos.map(d => <option key={d} value={d}>{d}</option>)}
                        <option value="Otro">Otro</option>
                      </select>
                    </div>
                    {formData.lugarNacimiento === 'Otro' && (
                      <div>
                        <label className="block text-sm font-medium mb-1">Especificar Lugar*</label>
                        <input type="text" name="lugarNacimientoOtro" value={formData.lugarNacimientoOtro} onChange={handleInputChange}
                          placeholder="Ingrese lugar" className="w-full px-3 py-2 border rounded-md" />
                      </div>
                    )}
                    <div>
                      <label className="block text-sm font-medium mb-1">Sexo*</label>
                      <select name="sexo" value={formData.sexo} onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md">
                        <option value="">Seleccionar</option>
                        <option value="M">Masculino</option>
                        <option value="F">Femenino</option>
                      </select>
                    </div>
                  </div>

                  {/* 3. Datos de Cuenta de Usuario (Solo nuevos estudiantes) */}
                  {!editingId && (
                    <div className="mb-6">
                      <h3 className="text-sm font-bold text-blue-800 uppercase tracking-wider mb-2 bg-blue-50 p-2 rounded">
                        Configuración de Acceso
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border border-blue-100 rounded-lg bg-white">
                        <div>
                          <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase">
                            Nombre de Usuario (Opcional)
                          </label>
                          <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleInputChange}
                            placeholder="Por defecto: Cédula de Identidad"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-semibold text-gray-600 mb-1 uppercase">
                            Contraseña (Opcional)
                          </label>
                          <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Por defecto: Cédula de Identidad"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Dirección*</label>
                      <input type="text" name="direccion" value={formData.direccion} onChange={handleInputChange}
                        placeholder="Ingrese dirección" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Número de Teléfono/Celular*</label>
                      <input type="tel" name="numeroTelefono" value={formData.numeroTelefono} onChange={handleInputChange}
                        placeholder="Ej: 71234567" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Correo Electrónico*</label>
                      <input type="email" name="correoElectronico" value={formData.correoElectronico} onChange={handleInputChange}
                        placeholder="ejemplo@correo.com" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>

                  {/* Familiar Cercano */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Nombres y Apellidos Familiar Cercano*</label>
                      <input type="text" name="familiarNombre" value={formData.familiarNombre} onChange={handleInputChange}
                        placeholder="Nombre completo" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Parentesco*</label>
                      <input type="text" name="familiarParentesco" value={formData.familiarParentesco} onChange={handleInputChange}
                        placeholder="Ej: Padre, Madre, Hermano" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Número de Teléfono/Celular*</label>
                      <input type="tel" name="familiarTelefono" value={formData.familiarTelefono} onChange={handleInputChange}
                        placeholder="Ej: 71234567" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>

                  {/* Contacto Emergencia */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Nombres y Apellidos Contacto Emergencia*</label>
                      <input type="text" name="emergenciaNombre" value={formData.emergenciaNombre} onChange={handleInputChange}
                        placeholder="Nombre completo" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Parentesco*</label>
                      <input type="text" name="emergenciaParentesco" value={formData.emergenciaParentesco} onChange={handleInputChange}
                        placeholder="Ej: Padre, Madre, Tío" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Número de Teléfono/Celular*</label>
                      <input type="tel" name="emergenciaTelefono" value={formData.emergenciaTelefono} onChange={handleInputChange}
                        placeholder="Ej: 71234567" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>

                  {/* Datos de Salud */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Tipo de Sangre*</label>
                      <select
                        name="tipoSangre"
                        value={formData.tipoSangre}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border rounded-md bg-white"
                      >
                        <option value="">Seleccione...</option>
                        <option value="A+">A+</option>
                        <option value="A-">A-</option>
                        <option value="B+">B+</option>
                        <option value="B-">B-</option>
                        <option value="AB+">AB+</option>
                        <option value="AB-">AB-</option>
                        <option value="O+">O+</option>
                        <option value="O-">O-</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Alergias*</label>
                      <input type="text" name="alergias" value={formData.alergias} onChange={handleInputChange}
                        placeholder="Ninguna o especificar" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Enfermedad de Base*</label>
                      <input type="text" name="enfermedadBase" value={formData.enfermedadBase} onChange={handleInputChange}
                        placeholder="Ninguna o especificar" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Lesiones u Otros Vinculados a su Salud*</label>
                      <input type="text" name="lesiones" value={formData.lesiones} onChange={handleInputChange}
                        placeholder="Ninguna o especificar" className="w-full px-3 py-2 border rounded-md" />
                    </div>
                  </div>
                </div>

                {/* 3. Pago de Inscripción */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">3. Pago de Inscripción</h3>

                  {(!paymentConfig || (!paymentConfig.qr_active && !paymentConfig.banco_active)) ? (
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
                      <div className="flex">
                        <div className="flex-shrink-0">
                          <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <p className="text-sm text-yellow-700">
                            Los métodos de pago en línea se encuentran temporalmente deshabilitados.
                            Por favor, consulte con el área administrativa para realizar su pago presencialmente.
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <p className="text-sm text-gray-600 mb-4">Puede efectuar su pago con cualquiera de los siguientes métodos de pago habilitados.</p>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {paymentConfig.qr_active && (
                          <div className="text-center p-4 border rounded-lg bg-white shadow-sm">
                            <h4 className="font-medium mb-2 text-blue-900">Pago mediante QR</h4>
                            <div className="w-40 h-40 border-2 rounded-lg mx-auto flex items-center justify-center overflow-hidden bg-gray-50">
                              {paymentConfig.qr_imagen_url ? (
                                <img src={paymentConfig.qr_imagen_url} alt="QR de Pago" className="w-full h-full object-contain" />
                              ) : (
                                <span className="text-gray-400 text-sm">QR no disponible</span>
                              )}
                            </div>
                            <p className="mt-2 text-xs text-gray-500 italic">Escanee el código desde su aplicación bancaria</p>
                          </div>
                        )}

                        {paymentConfig.banco_active && (
                          <div className="p-4 border rounded-lg bg-white shadow-sm">
                            <h4 className="font-medium mb-2 text-blue-900">Transferencia Bancaria</h4>
                            <div className="space-y-2 text-sm">
                              <div className="flex justify-between border-b border-gray-100 pb-1">
                                <span className="text-gray-500">Banco:</span>
                                <span className="font-medium">{paymentConfig.banco_nombre || 'No disponible'}</span>
                              </div>
                              <div className="flex justify-between border-b border-gray-100 pb-1">
                                <span className="text-gray-500">N° de Cuenta:</span>
                                <span className="font-medium">{paymentConfig.banco_cuenta || 'No disponible'}</span>
                              </div>
                              <div className="flex justify-between border-b border-gray-100 pb-1">
                                <span className="text-gray-500">Tipo:</span>
                                <span className="font-medium">Caja de Ahorros</span>
                              </div>
                              <div className="flex justify-between border-b border-gray-100 pb-1">
                                <span className="text-gray-500">Titular:</span>
                                <span className="font-medium">{paymentConfig.banco_titular || 'EBID'}</span>
                              </div>
                              <div className="mt-2 text-xs bg-blue-50 p-2 rounded text-blue-800">
                                <strong>Glosa:</strong> Pago inscripción {formData.nombres ? `- ${formData.nombres}` : ''}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>

                {/* 4. Documentación */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">4. Documentación</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {documents.map((doc) => (
                      <div key={doc.id}>
                        <label className="block text-sm font-medium mb-1">{doc.name}*</label>
                        <div className="relative">
                          {/* <input type="text" readOnly value={doc.file?.name || ''} placeholder="Seleccionar archivo" */}

                          <input
                            type="text"
                            readOnly
                            value={doc.file?.name || (doc.currentUrl ? 'Archivo guardado en preadmisión ✓' : '')}
                            placeholder="Seleccionar archivo"
                            className={`w-full px-3 py-2 border rounded-md pr-10 ${doc.currentUrl && !doc.file ? 'bg-green-50 border-green-300 text-green-700' : ''
                              }`}
                          />

                          <label className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer">
                            <Paperclip size={18} className="text-gray-400" />
                            <input type="file" onChange={(e) => handleFileChange(doc.id, e)} className="hidden" accept="image/*,.pdf" />
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 5. Declaración Jurada */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">5. Declaración Jurada</h3>
                  <div className="bg-gray-50 border rounded-md p-4 text-sm text-gray-700">
                    <p>
                      Yo <strong>{formData.nombres + ' ' + formData.apellidoPaterno + ' ' + formData.apellidoMaterno}</strong> hábil por derecho, con <strong>Cédula de Identidad N° {formData.cedulaIdentidad}</strong> de manera voluntaria acepto los términos establecidos en la Convocatoria y sus procesos de admisión y registro, así mismo declaro en honor a la verdad, que cumplo a cabalidad con los requisitos indispensables exigidos en la convocatoria, siendo que todos los datos proporcionados en el presente formulario son verídicos, por lo que autorizo que la información proporcionada sea verificada y contrastada por la EBID, comprometiéndome a la presentación de la documentación original de acuerdo al cronograma establecido. Asimismo, asumo plena responsabilidad por cualquier situación relacionada con mi salud o accidentes que pudiere ocurrir durante el desarrollo de mis actividades académicas y extracurriculares en la EBID. En este sentido, autorizo/no autorizo a la EBID que, si fuera necesario, contacte a un familiar o contacto de emergencia cuando sea necesario. En caso de no estar de acuerdo con lo estipulado, exonero a la institución de toda responsabilidad respecto de accidentes relacionados a mi persona y de salud dentro de la institución.
                    </p>
                  </div>
                </div>

                {/* Botón Guardar */}
                <div className="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-100">
                  <button onClick={handleSubmit}
                    className="px-10 py-3 bg-blue-900 text-white rounded-full hover:bg-blue-800 font-medium">
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Documentación */}
      {
        showDocModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
              <div className="border-b px-6 py-4 flex justify-between items-center">
                <h2 className="text-xl font-semibold text-blue-900">Documentación</h2>
                <button onClick={() => setShowDocModal(false)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
              </div>
              <div className="p-6">
                <table className="w-full">
                  <thead className="border-b-2">
                    <tr>
                      <th className="px-4 py-3 text-center font-semibold">No</th>
                      <th className="px-4 py-3 text-left font-semibold">Documento</th>
                      <th className="px-4 py-3 text-center font-semibold">Estado</th>
                      <th className="px-4 py-3 text-center font-semibold">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {documents.map((doc, index) => (
                      <tr key={doc.id} className="hover:bg-gray-50">
                        <td className="px-4 py-4 text-center">{index + 1}</td>
                        <td className="px-4 py-4 text-sm">{doc.name}</td>
                        <td className="px-4 py-4">
                          <div className="flex justify-center">
                            {doc.estado === 'aprobado' ? (
                              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                                <span className="text-white font-bold">✓</span>
                              </div>
                            ) : (
                              <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
                                <span className="text-white font-bold">✕</span>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex items-center justify-center">
                            <label className="p-2 text-blue-600 hover:bg-blue-50 rounded cursor-pointer">
                              <Paperclip size={18} />
                              <input type="file" className="hidden" onChange={(e) => handleFileChange(doc.id, e)} />
                            </label>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="flex justify-center mt-6">
                  <button onClick={() => setShowDocModal(false)}
                    className="px-10 py-3 bg-blue-900 text-white rounded-full hover:bg-blue-800 font-medium">
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal Ver Detalles Completos */}
      {
        showDetallesModal && selectedEstudiante && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
              <div className="bg-gray-50 px-6 py-4 border-b flex justify-between items-center flex-shrink-0">
                <div>
                  <h3 className="text-xl font-bold text-blue-900">
                    Detalles del Estudiante
                  </h3>
                  {/* <p className="text-sm text-gray-600">{selectedEstudiante.apellido_paterno || '-'} - {selectedEstudiante.nombres}</p> */}
                </div>
                <button onClick={() => setShowDetallesModal(false)} className="text-gray-400 hover:text-gray-600">
                  <X size={24} />
                </button>
              </div>
              {/* <div className="sticky top-0 bg-blue-900 text-white px-6 py-4 flex justify-between items-center">
                <h2 className="text-xl font-semibold">Detalles del Estudiante</h2>
                <button onClick={() => setShowDetallesModal(false)} className="text-white hover:text-gray-300"><X size={24} /></button>
              </div> */}
              <div className="p-6 space-y-6">
                {/* Datos Generales */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900  pb-2 mb-4">Datos Generales</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                    <div><span className="font-medium text-gray-600">Carrera:</span><p>{selectedEstudiante.carrera_nombre || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Mención:</span><p>{selectedEstudiante.mencion_nombre || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Modalidad:</span><p>{selectedEstudiante.modalidad_postulacion || '-'}</p></div>
                  </div>
                </div>

                {/* Datos Personales */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">Datos Personales</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                    <div><span className="font-medium text-gray-600">Nombres:</span><p>{selectedEstudiante.nombres || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Apellidos:</span><p>{`${selectedEstudiante.apellido_paterno || ''} ${selectedEstudiante.apellido_materno || ''}`.trim() || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">CI:</span><p>{selectedEstudiante.cedula_identidad || '-'} {selectedEstudiante.extension || ''}</p></div>
                    <div><span className="font-medium text-gray-600">Complemento:</span><p>{selectedEstudiante.complemento || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Fecha Nacimiento:</span><p>{selectedEstudiante.fecha_nacimiento ? new Date(selectedEstudiante.fecha_nacimiento).toLocaleDateString() : '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Edad:</span><p>{selectedEstudiante.fecha_nacimiento ? Math.floor((new Date() - new Date(selectedEstudiante.fecha_nacimiento)) / (365.25 * 24 * 60 * 60 * 1000)) : '-'} años</p></div>
                    <div><span className="font-medium text-gray-600">Sexo:</span><p>{selectedEstudiante.sexo || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Lugar Nacimiento:</span><p>{selectedEstudiante.lugar_nacimiento || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Dirección:</span><p>{selectedEstudiante.direccion || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Teléfono:</span><p>{selectedEstudiante.telefono || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Correo Electrónico:</span><p>{selectedEstudiante.email || '-'}</p></div>
                  </div>
                </div>

                {/* Familiar Cercano */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">Familiar Cercano</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                    <div><span className="font-medium text-gray-600">Nombre:</span><p>{selectedEstudiante.familiar_nombre || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Parentesco:</span><p>{selectedEstudiante.familiar_parentesco || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Teléfono:</span><p>{selectedEstudiante.familiar_telefono || '-'}</p></div>
                  </div>
                </div>

                {/* Contacto de Emergencia */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">Contacto de Emergencia</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                    <div><span className="font-medium text-gray-600">Nombre:</span><p>{selectedEstudiante.emergencia_nombre || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Parentesco:</span><p>{selectedEstudiante.emergencia_parentesco || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Teléfono:</span><p>{selectedEstudiante.emergencia_telefono || '-'}</p></div>
                  </div>
                </div>

                {/* Datos de Salud */}
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 pb-2 mb-4">Datos de Salud</h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div><span className="font-medium text-gray-600">Tipo de Sangre:</span><p>{selectedEstudiante.tipo_sangre || '-'}</p></div>
                    <div><span className="font-medium text-gray-600">Alergias:</span><p>{selectedEstudiante.alergias || 'Ninguna'}</p></div>
                    <div><span className="font-medium text-gray-600">Enfermedad de Base:</span><p>{selectedEstudiante.enfermedad_base || 'Ninguna'}</p></div>
                    <div><span className="font-medium text-gray-600">Lesiones u Otros:</span><p>{selectedEstudiante.lesiones || 'Ninguna'}</p></div>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-100">
                  <button onClick={() => setShowDetallesModal(false)}
                    className="px-10 py-3 bg-blue-900 text-white rounded-full hover:bg-blue-800 font-medium">
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal de Confirmación de Autorización */}
      {
        showConfirmModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="bg-white rounded-lg shadow-xl w-full max-w-md"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-gray-50 px-6 py-4 border-b flex justify-between items-center flex-shrink-0">
                <div>
                  <h3 className="text-xl font-bold text-blue-900">
                    Solicitud de Autorización
                  </h3>
                </div>
                <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); cancelarSolicitud(); }} className="text-gray-400 hover:text-gray-600">
                  <X size={24} />
                </button>
              </div>
              <div className="p-6">
                {/* <h2 className="text-xl font-semibold text-gray-800 mb-4">Solicitud de Autorización</h2>
                <p className="text-gray-600 mb-6">
                  Se solicitará a Dirección la autorización para editar la información de este estudiante.
                </p> */}

                <p className="text-sm text-gray-600">Se solicitará a Dirección la autorización para editar la información de este estudiante.</p>

                {pendingEditEstudiante && (
                  <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <p className="font-medium">{pendingEditEstudiante.nombres} {pendingEditEstudiante.apellido_paterno}</p>
                    <p className="text-sm text-gray-500">CI: {pendingEditEstudiante.cedula_identidad}</p>
                  </div>
                )}
                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); cancelarSolicitud(); }}
                    className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                  >
                    Rechazar
                  </button>
                  <button
                    type="button"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); solicitarAutorizacion(); }}
                    className="px-6 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800"
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal para motivo de rechazo */}
      {showSolModal && (
        <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-sm overflow-hidden border border-gray-200">
            <div className="bg-gray-50 px-5 py-3 border-b border-gray-100 flex justify-between items-center">
              <h3 className="font-bold text-gray-700 text-sm uppercase tracking-wider">Motivo del Rechazo</h3>
              <button onClick={() => setShowSolModal(false)} className="text-gray-400 hover:text-gray-600 p-1 transition-colors">
                <X size={18} />
              </button>
            </div>
            <div className="p-5">
              <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 text-amber-900 text-sm italic mb-5 leading-relaxed">
                "{selectedSolMessage}"
              </div>
              <button
                onClick={() => setShowSolModal(false)}
                className="w-full py-2.5 bg-gray-800 text-white rounded-lg text-sm font-semibold hover:bg-gray-700 transition-all active:scale-[0.98]"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}